import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useGoToFaq } from "@/hooks/useGoToFaq";

type InputProps = {
    anchor?: string;
};

export default function NeedHelpButton({
    anchor = "",
}: InputProps) {
    const { t } = useTranslation();
    const goToFaq = useGoToFaq();

    return (
        <div className="flex justify-center">
            <Button aria-label="Precisa de ajuda? Clique aqui" className="font-bold h-auto"
                size={"link"} variant={"link"} onClick={() => goToFaq(anchor)}>
                {t("common.need_help")}
            </Button>
        </div>
    );
}
